import { OopsPage } from '#src/App/OopsPage.tsx';
import { isObjectType } from '#src/utils/jsonSchema.ts';

import { webhookSchema } from '../webhookSchema.ts';

import { WebhookObjectSchemaPage } from './WebhookObjectSchemaPage.tsx';

export const WebhookSchemaRootPage = () => {
  if (!isObjectType(webhookSchema)) {
    return <OopsPage />;
  }

  return (
    <WebhookObjectSchemaPage
      heading={webhookSchema.title || 'Root object'}
      objectType={webhookSchema}
    />
  );
};
